import Layout2 from '@/layout/Layout2'
import { RouterTabRoutes } from 'vue-router-tab'

export default [{
  path: '/System',
  component: Layout2,
  children: [
    ...RouterTabRoutes,
    {
      path: 'Log/Login',
      meta: { title: '登录日志' },
      component: () => import('@/components/System/Log/Login')
    }, {
      path: 'Log/Version',
      meta: { title: '版本更新日志' },
      component: () => import('@/components/System/Log/Version')
    }]
}]
